import { useEffect, useState } from 'react';

const readVar = (name, fallback) => {
  if (typeof window === 'undefined') return fallback;
  const value = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  return value || fallback;
};

export const useThemeHex = (name = '--theme-primary', fallback = '#3cb377') => {
  const [value, setValue] = useState(() => readVar(name, fallback));

  useEffect(() => {
    const update = () => setValue(readVar(name, fallback));
    update();
    const observer = new MutationObserver(update);
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['style', 'class'] });
    return () => observer.disconnect();
  }, [name, fallback]);

  return value;
};